import { PaymentStatusEnum } from '@core/enums';

export interface PaymentStatusConfig {
  textKey: string;
  icon: string;
}

export const PAYMENT_ASSETS_PATH = '../assets/lib/icons/payments';

export const PAYMENT_STATUS_CONFIG: Record<PaymentStatusEnum, PaymentStatusConfig> = {
  [PaymentStatusEnum.APPROVED]:    { textKey: 'payment-methods.status.approved', icon: `${PAYMENT_ASSETS_PATH}/gateway/mp.svg` },
  [PaymentStatusEnum.REFUNDED]:    { textKey: 'payment-methods.status.approved', icon: `${PAYMENT_ASSETS_PATH}/gateway/mp.svg` },
  [PaymentStatusEnum.CHARGED_BACK]:{ textKey: 'payment-methods.status.approved', icon: `${PAYMENT_ASSETS_PATH}/gateway/mp.svg` },
  [PaymentStatusEnum.AUTHORIZED]:  { textKey: 'payment-methods.status.approved', icon: `${PAYMENT_ASSETS_PATH}/gateway/mp.svg` },
  [PaymentStatusEnum.PENDING]:     { textKey: 'payment-methods.status.pending',  icon: `${PAYMENT_ASSETS_PATH}/pending-icon.svg` },
  [PaymentStatusEnum.IN_PROCESS]:  { textKey: 'payment-methods.status.pending',  icon: `${PAYMENT_ASSETS_PATH}/pending-icon.svg` },
  [PaymentStatusEnum.IN_MEDIATION]:{ textKey: 'payment-methods.status.pending',  icon: `${PAYMENT_ASSETS_PATH}/pending-icon.svg` },
  [PaymentStatusEnum.REJECTED]:    { textKey: 'payment-methods.status.pending',  icon: `${PAYMENT_ASSETS_PATH}/pending-icon.svg` },
  [PaymentStatusEnum.ERROR]:       { textKey: 'payment-methods.status.pending',  icon: `${PAYMENT_ASSETS_PATH}/pending-icon.svg` },
  [PaymentStatusEnum.CANCELLED]:   { textKey: 'payment-methods.status.pending',  icon: `${PAYMENT_ASSETS_PATH}/pending-icon.svg` },
  [PaymentStatusEnum.DEALER]:      { textKey: 'payment-methods.status.dealer',   icon: `${PAYMENT_ASSETS_PATH}/pending-icon.svg` },
};

